import { useQuery } from "@tanstack/react-query";
import { listPublicPackages } from "./publicPackagesApi";

export const usePublicPackages = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["public", "packages"],
    queryFn: ({ signal }) => listPublicPackages(signal),
  });

  return { packages: data ?? [], isLoading };
};
